// import React, { useEffect, useMemo, useState } from 'react'
// import styled from 'styled-components'
// import { useBetting } from '../../../../../context/BettingContext'
// import { ChevronDown, ChevronUp } from 'lucide-react'
// import { getUID } from '../../../../../Helper'


// /* ---- styled-components: unchanged ---- */
// const StyledTable = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   font-family: 'Montserrat Alternates', sans-serif;
//   background: #000000;

//   @media (max-width: 768px) {
//     border-collapse: separate;
//     border-spacing: 0;
//   }
// `
// const StyledHeader = styled.div`
//   background: rgb(50, 55, 56);
//   color: #FF5C5C;
//   padding: 14px 8px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   font-size: 14px;
//   font-weight: bold;
//   font-family: 'Montserrat Alternates', sans-serif;
//   cursor: pointer;

//   @media (min-width: 769px) {
//     cursor: default;
//   }
// `
// const StyledTableHeader = styled.thead`
//   background-color: rgb(50, 55, 56);
//   color: #ffffff;
//   font-family: 'Montserrat Alternates', sans-serif;

//   @media (max-width: 768px) {
//     display: none;
//   }
// `
// const StyledTableHeaderCell = styled.th`
//   padding: 3px 16px;
//   text-align: left;
//   font-weight: bold;
//   color: #ffffff !important;
//   font-family: 'Montserrat Alternates', sans-serif;
// `
// const StyledTableRow = styled.tr`
//   background-color: #000000;
//   border-bottom: 1px solid rgb(50, 55, 56);
//   font-family: 'Montserrat Alternates', sans-serif;

//   @media (max-width: 768px) {
//     display: block;
//     margin: 8px 8px 12px 8px;
//     border: 1px solid rgb(50, 55, 56);
//     border-radius: 6px;
//     overflow: hidden;
//   }
// `
// const StyledTableCell = styled.td`
//   padding: 2px 10px;
//   color: #ffffff;
//   font-family: 'Montserrat Alternates', sans-serif;

//   @media (max-width: 768px) {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 10px 12px;
//     border-bottom: 1px solid rgb(50, 55, 56);
//     font-size: 12px;
//     min-width: 0;
//     gap: 8px;

//     &:last-child {
//       border-bottom: none;
//     }

//     &::before {
//       content: attr(data-label);
//       color: #FF5C5C;
//       font-weight: 600;
//       margin-right: 12px;
//       text-transform: none;
//       flex: 0 0 auto;
//     }
//   }
// `
// const CellValue = styled.span`
//   display: block;
//   max-width: 100%;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;

//   @media (max-width: 768px) {
//     flex: 1 1 auto;
//     min-width: 0;
//     text-align: right;
//   }
// `

// function BettingTable() {
//   // UI open/close
//   const [isOpen, setIsOpen] = useState(true)

//   // Always read matchId from URL: /match/fullmarket/event/:matchId
//   const matchId = useMemo(() => {
//     try {
//       const { pathname } = window.location
//       const parts = pathname.split('/').filter(Boolean)
//       const i = parts.findIndex(p => p.toLowerCase() === 'event')
//       if (i !== -1 && parts[i + 1]) return decodeURIComponent(parts[i + 1])
//       return decodeURIComponent(parts[parts.length - 1] || '')
//     } catch {
//       return null
//     }
//   }, [window.location.pathname]) // changing route triggers recompute

//   // User + token
//   const userId = useMemo(() => {
//     try { const id = getUID?.(); return id != null ? String(id) : null } catch { return null }
//   }, [])
//   const token = useMemo(() => (typeof window !== 'undefined' ? localStorage.getItem('token') : null), [window.location.href])

//   // Data state
//   const [rows, setRows] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [errorMsg, setErrorMsg] = useState('')
//    const placedbet = useBetting();
//   // Fetch bets (simple, resets on deps change)
//   useEffect(() => {
//     if (!userId || !matchId || !token) {
//       setRows([])
//       setLoading(false)
//       setErrorMsg('')
//       return
//     }

//     const controller = new AbortController()
//     const run = async () => {
//       try {
//         setLoading(true)
//         setErrorMsg('')
//         setRows([]) // clear old rows when match changes

//         const url = `https://api.ibitplay.com/sportsbetting/open/${userId}/${matchId}`
//         const res = await fetch(url, {
//           headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
//           signal: controller.signal,
//           cache: 'no-store'
//         })

//         if (!res.ok) {
//           let msg = `HTTP ${res.status}`
//           try { const j = await res.json(); msg = j?.message || msg } catch {}
//           setErrorMsg(msg)
//           setRows([])
//           return
//         }

//         const j = await res.json()
//         const bets = Array.isArray(j?.bets) ? j.bets : []
//         const normalized = bets.map((b, i) => ({
//           id: b.id ?? `${matchId}-${i}`,
//           selectionName: b.selection_name ?? '—',
//           odds: b.odds ?? '-',
//           stake: b.stake ?? 0
//         }))

//         setRows(normalized)
//       } catch (e) {
//         if (e?.name !== 'AbortError') {
//           setErrorMsg(e?.message || 'Failed to load bets')
//           setRows([])
//         }
//       } finally {
//         setLoading(false)
//       }
//     }
//     run()
//     return () => controller.abort()
//   }, [userId, matchId, token])

//   return (
//     <div style={{ width: '100%', background: '#000000', marginLeft: '3px', paddingTop: '8px', paddingBottom: '8px' }}>
//       <StyledHeader onClick={() => setIsOpen(!isOpen)}>
//         <span>My Bets</span>
//         {(typeof window !== 'undefined' && window.innerWidth < 768) && (
//           <span className="mobile-toggle">
//             {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
//           </span>
//         )}
//       </StyledHeader>

//       {(isOpen || (typeof window !== 'undefined' && window.innerWidth > 768)) && (
//         <StyledTable>
//           <StyledTableHeader>
//             <tr>
//               <StyledTableHeaderCell>Selection</StyledTableHeaderCell>
//               <StyledTableHeaderCell>Odds</StyledTableHeaderCell>
//               <StyledTableHeaderCell>Stake</StyledTableHeaderCell>
//             </tr>
//           </StyledTableHeader>

//           <tbody>
//             {loading && (
//               <StyledTableRow>
//                 <StyledTableCell data-label="Selection"><CellValue>Loading…</CellValue></StyledTableCell>
//                 <StyledTableCell data-label="Odds">—</StyledTableCell>
//                 <StyledTableCell data-label="Stake">—</StyledTableCell>
//               </StyledTableRow>
//             )}

//             {!loading && errorMsg && (
//               <StyledTableRow>
//                 <StyledTableCell data-label="Selection"><CellValue title={errorMsg}>Could not load bets</CellValue></StyledTableCell>
//                 <StyledTableCell data-label="Odds">—</StyledTableCell>
//                 <StyledTableCell data-label="Stake">—</StyledTableCell>
//               </StyledTableRow>
//             )}

//             {!loading && !errorMsg && rows.map(row => (
//               <StyledTableRow key={row.id}>
//                 <StyledTableCell data-label="Selection"><CellValue title={row.selectionName}>{row.selectionName}</CellValue></StyledTableCell>
//                 <StyledTableCell data-label="Odds">{row.odds}</StyledTableCell>
//                 <StyledTableCell data-label="Stake">{row.stake}</StyledTableCell>
//               </StyledTableRow>
//             ))}

//             {!loading && !errorMsg && rows.length === 0 && (
//               <StyledTableRow>
//                 <StyledTableCell data-label="Selection"><CellValue>No open bets</CellValue></StyledTableCell>
//                 <StyledTableCell data-label="Odds">—</StyledTableCell>
//                 <StyledTableCell data-label="Stake">—</StyledTableCell>
//               </StyledTableRow>
//             )}
//           </tbody>
//         </StyledTable>
//       )}
//     </div>
//   )
// }

// export default BettingTable
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { useBetting } from '../../../../../context/BettingContext'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { getUID } from '../../../../../Helper'

/* ---- styled-components (unchanged) ---- */
const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Montserrat Alternates', sans-serif;
  background: #000000;

  @media (max-width: 768px) {
    border-collapse: separate;
    border-spacing: 0;
  }
`
const StyledHeader = styled.div`
  background: rgb(50, 55, 56);
  color: #FF5C5C;
  padding: 14px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Montserrat Alternates', sans-serif;
  cursor: pointer;

  @media (min-width: 769px) {
    cursor: default;
  }
`
const StyledTableHeader = styled.thead`
  background-color: rgb(50, 55, 56);
  color: #ffffff;
  font-family: 'Montserrat Alternates', sans-serif;

  @media (max-width: 768px) {
    display: none;
  }
`
const StyledTableHeaderCell = styled.th`
  padding: 3px 16px;
  text-align: left;
  font-weight: bold;
  color: #ffffff !important;
  font-family: 'Montserrat Alternates', sans-serif;
`
const StyledTableRow = styled.tr`
  background-color: #000000;
  border-bottom: 1px solid rgb(50, 55, 56);
  font-family: 'Montserrat Alternates', sans-serif;

  @media (max-width: 768px) {
    display: block;
    margin: 8px 8px 12px 8px;
    border: 1px solid rgb(50, 55, 56);
    border-radius: 6px;
    overflow: hidden;
  }
`
const StyledTableCell = styled.td`
  padding: 2px 10px;
  color: #ffffff;
  font-family: 'Montserrat Alternates', sans-serif;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid rgb(50, 55, 56);
    font-size: 12px;
    min-width: 0;
    gap: 8px;

    &:last-child {
      border-bottom: none;
    }

    &::before {
      content: attr(data-label);
      color: #FF5C5C;
      font-weight: 600;
      margin-right: 12px;
      text-transform: none;
      flex: 0 0 auto;
    }
  }
`
const CellValue = styled.span`
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    flex: 1 1 auto;
    min-width: 0;
    text-align: right;
  }
`

function BettingTable() {
  const { placedBets } = useBetting() // refetch on successful placeBets()
  const [isOpen, setIsOpen] = useState(true)

  // Get matchId from URL: /match/fullmarket/event/:matchId
  const matchId = useMemo(() => {
    try {
      const { pathname } = window.location
      const parts = pathname.split('/').filter(Boolean)
      const i = parts.findIndex(p => p.toLowerCase() === 'event')
      if (i !== -1 && parts[i + 1]) return decodeURIComponent(parts[i + 1])
      return decodeURIComponent(parts[parts.length - 1] || '')
    } catch {
      return null
    }
  }, [window.location.pathname])

  // User + token
  const userId = useMemo(() => {
    try { const id = getUID?.(); return id != null ? String(id) : null } catch { return null }
  }, [])
  const token = useMemo(
    () => (typeof window !== 'undefined' ? localStorage.getItem('token') : null),
    [window.location.href]
  )

  // Data state
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  // Fetch bets — refetch whenever matchId/userId/token or placedBets.length changes
  useEffect(() => {
    if (!userId || !matchId || !token) {
      setRows([])
      setLoading(false)
      setErrorMsg('')
      return
    }

    const controller = new AbortController()

    const run = async () => {
      try {
        setLoading(true)
        setErrorMsg('')
        // clear rows only when match changes (optional)
        // setRows([])

        const url = `https://api.ibitplay.com/sportsbetting/open/${userId}/${matchId}`
        const res = await fetch(url, {
          headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
          signal: controller.signal,
          cache: 'no-store'
        })

        if (!res.ok) {
          let msg = `HTTP ${res.status}`
          try { const j = await res.json(); msg = j?.message || msg } catch {}
          setErrorMsg(msg)
          setRows([])
          return
        }

        const j = await res.json()
        const bets = Array.isArray(j?.bets) ? j.bets : []
        const normalized = bets.map((b, i) => ({
          id: b.id ?? `${matchId}-${i}`,
          selectionName: b.selection_name ?? '—',
          odds: b.odds ?? '-',
          stake: b.stake ?? 0
        }))

        setRows(normalized)
      } catch (e) {
        if (e?.name !== 'AbortError') {
          setErrorMsg(e?.message || 'Failed to load bets')
          setRows([])
        }
      } finally {
        setLoading(false)
      }
    }

    run()
    return () => controller.abort()
  }, [userId, matchId, token, placedBets.length])

  return (
    <div style={{ width: '100%', background: '#000000', marginLeft: '3px', paddingTop: '8px', paddingBottom: '8px' }}>
      <StyledHeader onClick={() => setIsOpen(!isOpen)}>
        <span>My Bets</span>
        {(typeof window !== 'undefined' && window.innerWidth < 768) && (
          <span className="mobile-toggle">
            {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </span>
        )}
      </StyledHeader>

      {(isOpen || (typeof window !== 'undefined' && window.innerWidth > 768)) && (
        <StyledTable>
          <StyledTableHeader>
            <tr>
              <StyledTableHeaderCell>Selection</StyledTableHeaderCell>
              <StyledTableHeaderCell>Odds</StyledTableHeaderCell>
              <StyledTableHeaderCell>Stake</StyledTableHeaderCell>
            </tr>
          </StyledTableHeader>

          <tbody>
            {loading && (
              <StyledTableRow>
                <StyledTableCell data-label="Selection"><CellValue>Loading…</CellValue></StyledTableCell>
                <StyledTableCell data-label="Odds">—</StyledTableCell>
                <StyledTableCell data-label="Stake">—</StyledTableCell>
              </StyledTableRow>
            )}

            {!loading && errorMsg && (
              <StyledTableRow>
                <StyledTableCell data-label="Selection"><CellValue title={errorMsg}>Could not load bets</CellValue></StyledTableCell>
                <StyledTableCell data-label="Odds">—</StyledTableCell>
                <StyledTableCell data-label="Stake">—</StyledTableCell>
              </StyledTableRow>
            )}

            {!loading && !errorMsg && rows.map(row => (
              <StyledTableRow key={row.id}>
                <StyledTableCell data-label="Selection"><CellValue title={row.selectionName}>{row.selectionName}</CellValue></StyledTableCell>
                <StyledTableCell data-label="Odds">{row.odds}</StyledTableCell>
                <StyledTableCell data-label="Stake">{row.stake}</StyledTableCell>
              </StyledTableRow>
            ))}

            {!loading && !errorMsg && rows.length === 0 && (
              <StyledTableRow>
                <StyledTableCell data-label="Selection"><CellValue>No open bets</CellValue></StyledTableCell>
                <StyledTableCell data-label="Odds">—</StyledTableCell>
                <StyledTableCell data-label="Stake">—</StyledTableCell>
              </StyledTableRow>
            )}
          </tbody>
        </StyledTable>
      )}
    </div>
  )
}

export default BettingTable
